import { FrequencySelection } from '../types/autopar';

export function roundUp(value: number): number {
  const str = String(value);
  if (!str.length) return 0;
  const hasDecimal = str.includes('.');
  return hasDecimal ? Math.round(value + 0.5) : Math.round(value);
}

export function computeMonthlyOrders(
  baseOrdersPerMonth: number,
  frequencySelection: FrequencySelection,
  frequencyValue: number
): number {
  switch (frequencySelection) {
    case '0':
      return baseOrdersPerMonth;
    case '1':
      return baseOrdersPerMonth * 2;
    case '2':
      return baseOrdersPerMonth * 3;
    case '3':
      // perWeek * 4
      return frequencyValue * 4;
    case '4':
      // perMonth
      return frequencyValue;
    default:
      return baseOrdersPerMonth;
  }
}

export function getAutoPar(
  maxMonthUsage: number,
  monthUsage: number,
  monthOrders: number,
  reservePercent: number
): number {
  let monthlyMax: number;
  if (maxMonthUsage > monthUsage * 3) {
    monthlyMax = monthUsage;
  } else {
    monthlyMax = maxMonthUsage - (maxMonthUsage - monthUsage) / 2;
  }

  if (monthOrders === 0) return 0;

  const base = monthlyMax / monthOrders;
  const reserve = (reservePercent / 100) * base;
  return roundUp(base + reserve);
}
